import { useMemo } from 'react'

import { PortTypeInfo } from '@/lib/definitions/api.types'
import { generateBandwidthsData } from '@/lib/misc/Utils'
import { useLoadPortTypes } from '@/lib/queries/Services.queries'
import { PortSpeed } from '@/pages/ServiceWizard/ServiceWizard.types'

const portTypeLinks: Record<string, string> = {
  '1G-LX (SFP)': 'https://www.flexoptix.net/en/s-1312-10-d.html',
  '10G-LR (SFP+)': 'https://www.flexoptix.net/en/p-1396-10.html',
  '25G-LR (SFP28)': 'https://www.flexoptix.net/en/p-1325g-10.html',
  '100G-LR4 (QSFP28)': 'https://www.flexoptix.net/en/q-161hg-10.html',
  '100G-LR1 (QSFP28)': 'https://www.flexoptix.net/en/q-13s1hg-10.html',
  '400G-LR4 (OSFP/QSFP-DD)': 'https://www.flexoptix.net/en/d-134hg-05.html',
}

export const toPortSpeed = (
  name: string,
  speedInMbps: number,
  id = 0
): PortSpeed => ({
  id,
  ...generateBandwidthsData(speedInMbps),
  type: name.split(' (')[0],
  name,
  link: portTypeLinks[name],
})

export const isPortSpeedAllowed = (
  port: PortSpeed,
  allowLR1: boolean | undefined
): boolean => !!allowLR1 || !port.type.endsWith('-LR1')

export const buildPortSpeedOptions = (
  portTypes: readonly PortTypeInfo[]
): PortSpeed[] =>
  portTypes.map((portType, index) =>
    toPortSpeed(portType.name, portType.speed_mbps, index + 1)
  )

export const usePortSpeedOptions = (): PortSpeed[] => {
  const { data } = useLoadPortTypes()
  return useMemo(() => buildPortSpeedOptions(data ?? []), [data])
}
